import React, { PureComponent } from 'react';
import Sticky from 'sticky-js';
import { scroller } from 'react-scroll';
import { variables } from '../../../config/postcss.config';
import styles from './Awards.css';
import SectionTitle from '../../components/SectionTitle';
import RoundTab from '../../components/RoundTab';
import AwardBlock from '../../components/AwardBlock';
import loadJSON from '../../lib/loadJSON';
import { Element } from 'react-scroll';
import { gcpURL } from '../../lib/utils';

const icon = `${gcpURL}/static/ic-award.svg`;

const AwardList = ({ isActive, children }) => (
  <div className={`${styles.awardList} ${isActive ? styles.isActive : ''}`}>
    {children}
  </div>
);

class Awards extends PureComponent {
  state = {
    active: 1,
    awards: [],
  };

  componentDidMount() {
    // only activate in mobile
    if (window.innerWidth <= variables.variables.mobile) {
      new Sticky(`.${styles.awardTabList}`);
    }

    loadJSON()
      .then((data) => {
        this.setState({
          awards: data.awards,
        });
      })
      .catch((err) => {
        this.setState({
          isError: true,
          error: err,
        });
      });
  }

  handleTabClick = target => () => {
    this.setState({
      active: target,
    });

    scroller.scrollTo('獎項列表', {
      duration: 500,
      smooth: true,
    });
  }

  render() {
    const { active, awards } = this.state;

    return (
      <section className={`${styles.awards} container`}>
        <Element name="獎項列表" />
        <SectionTitle title="獎項列表" icon={icon} />

        <ul className={styles.awardTabList} data-margin-top="60" data-sticky-class={styles.sticky} data-sticky-wrap>
          {awards.map((award, i) => (
            <RoundTab key={award.title} title={award.title} num={award.list.length} isActive={active === i + 1} onClick={this.handleTabClick(i + 1)} />
          ))}
        </ul>

        {awards.map((award, i) => (
          <AwardList key={award.title} isActive={active === i + 1}>
            {award.list.map((block, j) => (
              <AwardBlock
                key={`${block.awardTitle}-${j}`}
                className={block.isLong && (!block.hasWinner || block.isMulti) ? styles.awardLong : null}
                {...block}
              />
            ))}
          </AwardList>
        ))}
      </section>
    );
  }
}

export default Awards;



// WEBPACK FOOTER //
// ./src/sections/Awards/index.js